import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import DOMPurify from 'dompurify';

const SingleBlog = () => {
  const { slug } = useParams(); 
  // const { blogId } = useLocation().state;
  const { blogId } = useParams();;
  console.log("blogId");
  console.log(blogId);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [blogData, setBlogData] = React.useState({
    title: '',
    author: '',
    publish_date: '',
    image_url: '',
    excerpt: '',
    introduction: '',
    main_content: '',
    conclusion: '',
    tags: [],
    meta_title: '',
    meta_description: '',
  });

  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  const formatDate = (dateArray) => {
    const [year, month, day] = dateArray;
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };
  // Fetch blog data by ID
  const fetchBlogData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/all/blogs/${blogId}`);
      if (response.status === 200) {
        const data = response.data.blog;
        setBlogData({
          title: data.title,
          author: data.author,
          publish_date: formatDate(data.publish_date),
          image_url: data.image_url,
          excerpt: data.excerpt,
          introduction: data.content,
          tags: data.tags.split(','), // tags are comma separated
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        });
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogData();
  }, [slug, blogId]);


  return (
    <Container>
      <Row className="justify-content-center my-4">
        <Col lg={9} md={8} sm={12}>
          <Card border="0" className="shadow-lg p-4 mb-4">
            <div className="text-center mb-4">
              <h1 className="fw-bold mb-3">{blogData.title || 'Loading...'}</h1>
              <p className="text-muted mb-1">
                By <strong>{blogData.author || 'Unknown'}</strong> |{' '}
                <small>Published on {blogData.publish_date || '-'}</small>
              </p>
              {blogData.image_url && (
                <img
                  src={blogData.image_url}
                  alt="Blog Image"
                  className="img-fluid rounded-4 mt-4"
                  style={{ maxHeight: '400px', objectFit: 'cover' }}
                />
              )}
            </div>

            <div>
              <p className="lead fst-italic">{blogData.excerpt || 'Excerpt loading...'}</p>
            </div>

            <div className="py-4">
              <h2 className="text-primary">Introduction</h2>
              <div 
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogData.introduction || 'Introduction loading...') }}
              />
            </div>

            <div className="pt-4 border-top">
              <p className="mb-1">
                <strong className='pe-3'>Tags:</strong>
                {blogData.tags.length > 0 ? (
                  blogData.tags.map((tag, index) => (
                    <Badge key={index} bg="primary" className="me-1">
                      {tag}
                    </Badge>
                  ))
                ) : (
                  <span>No tags available</span>
                )}
              </p>
              <small className="text-muted">
                Meta Title: {blogData.meta_title || 'No meta title'} | Meta Description: {blogData.meta_description || 'No description'}
              </small>
            </div>
          </Card>
          <Link to="/" className="text-decoration-none">
            <Button variant="primary">Back to Home</Button>
          </Link>
        </Col>
          
      </Row>
    </Container>
  );
};

export default SingleBlog;
